(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
$(document).ready(function() {
  // Initialize the Slick slider for brands
  $('.brands-responsive').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-img"] && !Shopify.designMode) return;
  try {
    
// form a brands slider with slick
$('.brands-responsive').slick({
    slidesToShow: 4,  // Show only one slide at a time
    slidesToScroll: 4,
    autoplay: true,  // Disable autoplay
    arrows: false, 
    dots: false,
  autoplaySpeed: 2000,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

  } catch(e) { console.error(e); }
})();
})();
